export default {
  MASTERPLAN_0: '0',
  MASTERPLAN_120: '120',
  MASTERPLAN_240: '240',
}
